import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/api-client';

export const TENANT_SLUG = import.meta.env.VITE_TENANT_SLUG || '';

export interface TenantConfig {
  id: string;
  name: string;
  code: string;
  authProvider?: 'oauth' | 'clerk';
  clerkPublishableKey?: string | null;
}

/**
 * Fetch the public tenant config — it must have `authProvider: 'clerk'` and
 * supplies the Clerk publishable key (same tenant-driven config the pickem
 * frontend uses).
 */
export function useTenantConfig() {
  return useQuery({
    queryKey: ['tenant', TENANT_SLUG],
    queryFn: async (): Promise<TenantConfig> => {
      const response = (await apiClient.get(`/api/tenants/${TENANT_SLUG}`)) as unknown as {
        tenant: TenantConfig;
      };
      return response.tenant;
    },
    enabled: !!TENANT_SLUG,
    staleTime: 1000 * 60 * 5,
    retry: 3,
  });
}
